import React from 'react'
import { withRouter } from 'react-router-dom'
import NavigationBarAndDrawer from '../NavigationBarAndDrawer'
import { AccountContext } from '../../providers/accountProvider'
import { get } from '../../lib/api'
import ErrorBoundary from '../ErrorBoundary'
import { ErrorComponent } from '../ErrorPage'
import { notifyBugsnag } from '../ErrorBoundary'
import FreshChat from '../FreshChat'
import GenericError from '../GenericError'
import { UpdateNoticeToast } from '../Toast'
import Alerts from '../Alerts'
import ChatBotContainer from '../ChatBotContainer'

// for menu object
// if showOnlyTo property is not present, show it to all roles, if showOnlyTo: [] -> show it to none
// if showOnlyTo: [some values], show it to all roles mentioned in array
export const menuItemsArray = [
  {
    slug: 'home',
    label: 'Home',
    link: '/home',
  },
  {
    slug: 'novels',
    label: 'Novels',
    link: '/shows/novels',
  },
  {
    slug: 'my-creations',
    label: 'My Creations',
    link: '/my-creations',
  },
  {
    slug: 'writers-benefit',
    label: 'Writer’s Benefit',
    link: '/writers-benefit',
  },
  {
    slug: 'income',
    label: 'Income',
    link: '/income',
  },
  {
    slug: 'analytics',
    label: 'Analytics',
    link: '/analytics',
  },
  {
    slug: 'writer’s academy',
    label: 'Writer’s Academy',
    link: '/writers-academy',
  },
]

// Note: No two routes should have same slug, irrespective of parant

const filterItemsFromSingleLevelMenu = (childArray, userRoles) => {
  return childArray
    ? childArray.filter((childItem) =>
        !childItem.showOnlyTo
          ? true
          : childItem.showOnlyTo.some((grantedRole) =>
              userRoles.includes(grantedRole)
            )
      )
    : null
}

const filterItemsFromMenu = (menuArray, roles = '') => {
  const userRoles = roles
  return menuArray.reduce((finalMenu, mainMenu) => {
    if (!mainMenu.showOnlyTo) {
      return finalMenu
        .concat({
          ...mainMenu,
          submenu: filterItemsFromSingleLevelMenu(mainMenu.submenu, userRoles),
        })
        .filter(Boolean)
    } else {
      return mainMenu.showOnlyTo.some((grantedRole) =>
        userRoles.includes(grantedRole)
      )
        ? finalMenu
            .concat({
              ...mainMenu,
              submenu: filterItemsFromSingleLevelMenu(
                mainMenu.submenu,
                userRoles
              ),
            })
            .filter(Boolean)
        : finalMenu
    }
  }, [])
}

export const menuItemObj = menuItemsArray.reduce((obj, item) => {
  if (item.submenu) {
    item.submenu.reduce((object, sub) => {
      obj[sub.slug] = sub.link
    }, {})
  }
  obj[item.slug] = item.link
  return obj
}, {})

class PrivatePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      apiError: false,
      isHelpButtonVisible: false,
    }
    this.handleError = this.handleError.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.key !== prevProps.location.key
    ) {
      this.setState({ message: '', apiError: false })
    }
  }

  handleError(e) {
    e.preventDefault()
    console.error(e.reason)
    console.error('stack', e.reason.stack)
    const locale = this.props?.user?.location || ''
    const language = this.props?.user?.languages || ''
    if (e.reason.code === 401 || e.reason.code === 403) {
      this.props.history.push('/logout')
    } else if (e.reason.message === 'cancelled') {
      // do nothing
    } else {
      notifyBugsnag(e.reason.message || 'unidentified error', {
        ...e.reason,
        locale,
        language,
      })
      if (e.reason.message === 'author name missing') {
        this.setState({
          message: [
            'please update your name first! click ',
            <strong onClick={() => this.props.history.push('/edit-profile')}>
              HERE
            </strong>,
            ' to update',
          ],
          apiError: true,
        })
        return
      }
      if (e.reason.message === 'Word Count cannot be 0') {
        this.setState({ message: 'Word Count cannot be 0 ', apiError: true })
        return
      }
      if (
        e.reason.message === 'a is not a function' ||
        e.reason.message === 'r is not a function'
      ) {
        return
        // TODO: this is just a hotfix. remove this after error is identified and fixed
      }
      this.setState({ message: e.reason.message || '', apiError: true })
    }
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.handleError)
    get('/user_api/user.get_creator_details?is_novel=1').then((res) => {
      localStorage.setItem('image_url', res.result.image_url)
      this.props.onUpdateUser(res.result)
    })
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.handleError)
  }

  render() {
    const child = React.Children.only(this.props.children)
    const { location, match, history, user, isProfileNameShown } = this.props
    const newProps = { location, match, history, user }
    const isUserFromIndia = user?.location === 'IN' || user?.location === 'US'

    const tabFilterOnLanguageBasis = ['hindi', 'tamil', 'english'].includes(
      user.languages
    )
    const { pathname } = location
    const isFreshChatIconVisible =
      pathname === '/writers-benefit' ||
      pathname.includes('/writers-academy') ||
      tabFilterOnLanguageBasis
    isFreshChatIconVisible ? window?.fcWidget?.hide() : window?.fcWidget?.show()
    return (
      <>
        <GenericError
          message={this.state.message}
          show={this.state.apiError}
          onClose={() => this.setState({ message: '', apiError: false })}
        />
        <UpdateNoticeToast />
        <Alerts />
        <FreshChat />
        {tabFilterOnLanguageBasis &&
          pathname !== '/writers-benefit' &&
          !pathname.includes('/writers-academy') &&
          !pathname.includes('add-chapter') &&
          !pathname.includes('edit-chapter') &&
          !pathname.includes('/my-creations') && (
            <ChatBotContainer
              isHelpButtonVisible={this.state.isHelpButtonVisible}
              handleFaqIcon={() => {
                this.props.history.push(`/faqs`)
              }}
              toggleHelperIcon={() =>
                this.setState({
                  isHelpButtonVisible: !this.state.isHelpButtonVisible,
                })
              }
            />
          )}
        <NavigationBarAndDrawer
          menuItemsArray={filterItemsFromMenu(
            menuItemsArray,
            user.account_type
          )}
          revenue_tab={user?.revenue_tab}
          analytics_tab={user?.analytics}
          isProfileNameShown={isProfileNameShown}
          tabFilterOnLanguageBasis={tabFilterOnLanguageBasis}
          authorVisibility={user?.author_visibility}
          authorLanguage={user?.languages}
          authorLocation={user?.location}
          badge={user?.author_tier?.replace('_writer', '')}
        >
          <ErrorBoundary FallbackComponent={ErrorComponent}>
            {React.cloneElement(child, {
              ...newProps,
            })}
          </ErrorBoundary>
        </NavigationBarAndDrawer>
      </>
    )
  }
}

const PrivatePageWrapper = (props) => (
  <AccountContext.Consumer>
    {({ onUpdateUser, user }) => (
      <PrivatePage onUpdateUser={onUpdateUser} user={user} {...props} />
    )}
  </AccountContext.Consumer>
)

export default withRouter(PrivatePageWrapper)
